"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Request = require("./_request-api");
var constants_1 = require("../data/constants");
var processPurchase = function (purchase) {
    if (!purchase) {
        return purchase;
    }
    if (Array.isArray(purchase)) {
        purchase.forEach(processPurchase);
        return purchase;
    }
    return Object.assign(purchase, {
        need_rating: ratingNeeded(purchase),
        status: status(purchase),
    });
};
var status = function (purchase) {
    if (purchase["refunded_at"]) {
        return "refunded";
    }
    if (purchase["finished_at"]) {
        return "finished";
    }
    if (purchase["accepted_at"]) {
        return "accepted";
    }
    return "pending";
};
var all = function (scope, page) {
    if (page === void 0) { page = 1; }
    return Request.sendGet(constants_1.endpoints.api + "/" + scope + "_purchases", {
        page: page,
    })
        .then(processPurchase);
};
exports.all = all;
var get = function (id) {
    return Request.sendGet(constants_1.endpoints.api + "/purchases/" + id)
        .then(processPurchase);
};
exports.get = get;
var create = function (offer, expert) {
    if (expert === void 0) { expert = null; }
    var data = {
        offer_id: offer["id"],
    };
    if (expert) {
        data["admin_id"] = expert["id"];
    }
    return Request.sendPost(constants_1.endpoints.api + "/purchases", data)
        .then(processPurchase);
};
exports.create = create;
var save = function (purchase, data) {
    var serviceType = purchase["offer"]["service_type"];
    return Request.sendPut(constants_1.endpoints.api + "/" + serviceType + "_services/" + purchase["id"], data)
        .then(processPurchase);
};
exports.save = save;
var pay = function (purchase) {
    return Request.sendPost(constants_1.endpoints.api + "/purchase_payments", {
        purchase_id: purchase["id"],
        card_id: purchase["card_id"],
    })
        .then(processPurchase);
};
exports.pay = pay;
var canAccept = function (purchase) {
    if (purchase["accepted_at"]) {
        return false;
    }
    if (purchase["refunded_at"]) {
        return false;
    }
    return purchase["service"]["creator_type"] === "Admin";
};
exports.canAccept = canAccept;
var accept = function (purchase) {
    if (!canAccept(purchase)) {
        throw "Cannot accept purchase " + purchase["id"];
    }
    return Request.sendPost(constants_1.endpoints.api + "/accept_purchases", {
        purchase_id: purchase["id"],
    })
        .then(processPurchase);
};
exports.accept = accept;
var canRefund = function (purchase) {
    if (purchase["service_type"] === "call") {
        return false;
    }
    if (!!purchase["refunded_at"]) {
        return false;
    }
    if (!purchase["payed_at"]) {
        return false;
    }
    if (!!purchase["finished_at"]) {
        return false;
    }
    return true;
};
exports.canRefund = canRefund;
var refund = function (purchase) {
    if (!canRefund(purchase)) {
        throw "Cannot refund purchase " + purchase["id"];
    }
    return Request.sendPost(constants_1.endpoints.api + "/refunds", {
        purchase_id: purchase["id"],
    })
        .then(processPurchase);
};
exports.refund = refund;
var toReview = function () {
    return Request.sendGet(constants_1.endpoints.api + "/waiting_for_review_purchases")
        .then(processPurchase);
};
exports.toReview = toReview;
var ratingNeeded = function (purchase) {
    if (!purchase["finished_at"]) {
        return false;
    }
    if (purchase["rating"]) {
        return false;
    }
    if (purchase["refunded_at"]) {
        return false;
    }
    if (purchase["offer"]["service_type"] === "prepaid_minute") {
        return false;
    }
    if (purchase["offer"]["service_type"] === "phone") {
        return purchase["service"]["call"]["status"] === "completed";
    }
    return true;
};
exports.ratingNeeded = ratingNeeded;
//# sourceMappingURL=purchase.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/purchase.js
// module id = 910
// module chunks = 3